import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiButton, UiQuestionnaireLayout, UiSimpleGrid, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_TWO_KEYS, WEIGHT_LOSS_TWO_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const MDQ2Questionnaire6Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_TWO_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_TWO_KEYS.EATING_HABITS);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_TWO_KEYS.EATING_HABITS]?.data,
  );

  const collectedData = mdq.collectedData;

  const {inputs, setInputs, validation} = useInput({
    selectedOption: currentAnswer?.selectedOption || 0,
  });

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_TWO_KEYS.EATING_HABITS,
      index: questionnaire?.index || '',
      data: {
        selectedOption: inputs?.selectedOption,
      },
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_TWO_KEYS.EATING_HABITS]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.BMI_CALCULATOR}));
    history.push(PAGE_URLS.MDQ2_TAKE_WEIGHT_LOSS_BEFORE + window.location.search);
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      actions={questionnaire?.actions}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      pageTitle={questionnaire?.title}
      disableNext={!inputs.selectedOption}
    >
      <Col textAlign="center" mt={20} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={6}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiSimpleGrid columns={1} spacing={4}>
          {questionnaire?.options?.map(value => (
            <UiButton
              key={`${value.label}-${value.value}`}
              title={value.label}
              variant={inputs.selectedOption === value.value ? 'primary' : 'outline'}
              onClick={() => setInputs({selectedOption: value.value})}
              whiteSpace="pre-wrap"
              color="trueBlack"
              borderColor="trueBlack"
              fontWeight={500}
              borderRadius={48}
              minH={16}
              _hover={{}}
            />
          ))}
        </UiSimpleGrid>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQ2Questionnaire6Screen;
